import { ReactNode } from 'react';
import { LuBedSingle } from 'react-icons/lu';

import {
  bedBathroomTypesEnum,
  shortBedBathroomTypesEnum,
  shortBedBathroomTypesPluralEnum,
} from '@/utils/roomsMap';

import Bath from '../Icons/Bath';
import ShowerIcon from '../Icons/Shower';
import TwinBedIcon from '../Icons/TwinBed';
import Bed from '../Icons/Bed';
import BunkBedIcon from '../Icons/BunkBed';
import FrenchBedIcon from '../Icons/FrenchBed';
import SofaIcon from '../Icons/Sofa';

type Props = {
  enumString: string;
  lang: string;
  total?: number;
};

export const bedBathroomIconEnum: { [key: string]: ReactNode } = {
  'enum.bed_type.single': <LuBedSingle className="text-gray-500 w-7 h-7" />,
  'enum.bed_type.double': <Bath />,
  'enum.bed_type.twin': (
    <TwinBedIcon className="fill-current text-gray-500 w-7 h-7" />
  ),
  'enum.bathroom_type.ensuite_shower': (
    <ShowerIcon className="fill-current text-gray-500 w-6 h-6" />
  ),
  'enum.bathroom_type.shower': (
    <ShowerIcon className="fill-current text-gray-500 w-6 h-6" />
  ),
  'enum.bed_type.bunk': (
    <BunkBedIcon className="fill-current text-gray-600 w-6 h-6" />
  ),
  'enum.bed_type.french': (
    <FrenchBedIcon className="fill-current text-gray-600 w-6 h-6" />
  ),
  'enum.bed_type.sofa': (
    <SofaIcon className="fill-current text-gray-600 w-6 h-6" />
  ),
  'enum.bathroom_type.ensuite_bathtub': <Bed />,
  'enum.bathroom_type.ensuite_bath_shower': <Bed />,
};

export default function RoomsEnumBedAndBathroomsType({
  enumString,
  lang,
  total,
}: Props) {
  const enumLabel = bedBathroomTypesEnum?.[enumString]?.[lang];
  const Icon = bedBathroomIconEnum?.[enumString];

  const shortEnumLabel =
    shortBedBathroomTypesEnum?.[enumString]?.[lang] ?? enumString;
  const pluralShortEnumLabel =
    shortBedBathroomTypesPluralEnum?.[enumString]?.[lang] ?? enumString;

  if (total) {
    return (
      <li className="mb-[0.625rem]">
        <span className="min-w-6 inline-block text-right mr-[6px]">
          {total}
        </span>
        {total > 1 ? pluralShortEnumLabel : shortEnumLabel}
      </li>
    );
  }

  return (
    <div className="mr-8 mb-2 flex items-center gap-3">
      {Icon && (
        <div className="h-8 flex justify-center items-start">{Icon}</div>
      )}
      <span className="h-8">{enumLabel ? enumLabel : enumString}</span>
    </div>
  );
}
